import { render, staticRenderFns } from "./PaymentsCard.vue?vue&type=template&id=5aa36de8&"
import script from "./PaymentsCard.vue?vue&type=script&lang=js&"
export * from "./PaymentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports